import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Pillars from "@/components/Pillars";
import AppDownload from "@/components/AppDownload";
import ReviewsEmpty from "@/components/ReviewsEmpty";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";
import { ProductGrid } from "@/components/Products";
import Reveal from "@/components/Reveal";
import { api } from "@/lib/api";

export default function LandingPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products")
      .then((res) => setProducts(res.data.filter((p) => p.featured)))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#061536] text-white min-h-screen overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Pillars />

      <section id="aiot" className="py-24 px-6 bg-[#040D26] border-t border-[#00F0FF]/20 scroll-mt-20" data-testid="aiot-showcase-section">
        <div className="max-w-6xl mx-auto">
          <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
            <div>
              <span className="font-mono-lbl text-xs text-[#00F0FF] uppercase tracking-widest block mb-2">Hardware Storefront</span>
              <h2 className="font-disp text-4xl sm:text-5xl uppercase tracking-tight"><span className="normal-case">AIoT</span> Device Catalog</h2>
            </div>
            <Link
              to="/mart"
              className="font-mono-lbl text-xs text-[#00F0FF] hover:underline uppercase mt-4 md:mt-0"
              data-testid="view-all-devices-link"
            >
              Explore AIoT Mart →
            </Link>
          </div>
          </Reveal>
          <ProductGrid products={products} loading={loading} />
        </div>
      </section>

      <AppDownload />
      <ReviewsEmpty />
      <EnquiryForm />
      <Footer />
    </div>
  );
}
